import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from '../services/util.service';
import * as constant from '../constants/constants'

/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({ name: 'thousandSeparator' })
export class ThousandSeparator implements PipeTransform {
    constructor(private util: UtilService) { }

    /** Transform Function */
    transform(original_value: any, decimal_points:any = 2): any {
        const configuration = this.util.getValuesFromSessionStorage(constant.storage_keys.configuration);
        const currency_details = this.extractCurrencyDetails(configuration);
        const formated_value =  this.formatValue(original_value, currency_details, decimal_points)
        return formated_value
    }

    /** Extract the Currency Details From Configuration */
    private extractCurrencyDetails(configuration: any) {
        return {
            code: configuration[constant.configuration_keys.language_code],
            name: configuration[constant.configuration_keys.currency_name],
            symbol: configuration[constant.configuration_keys.currency_symbol],
        };
    }

    /** Format the Original Value to the required Format */
    private formatValue(original_value: any, currency_details: any, decimal_points: any) {
        let formated_value = '-';
        if (original_value !== "-" && !this.util.isNullOrEmptyOrUndefined(original_value)) {

            //Format According to currency details
            const formatter = new Intl.NumberFormat(currency_details.code, {
                style: 'currency',
                currency: currency_details.name,
                minimumFractionDigits: decimal_points
            });
            
            //Format According to currency details
            const zero_formatter = new Intl.NumberFormat(currency_details.code, {
                style: 'currency',
                currency: currency_details.name,
                minimumFractionDigits: decimal_points
            });

            if(original_value != 0 ){
                formated_value = formatter.format(this.cleanValue(original_value, currency_details.symbol))
                    .replace(currency_details.symbol, "").trim();
            }
            
            if(original_value == 0 ){
                formated_value = zero_formatter.format(this.cleanValue(original_value, currency_details.symbol))
                    .replace(currency_details.symbol, "").trim();
            }

            // Handle special formatting cases
            if (original_value.includes("(") && original_value.includes(")") && Number(formated_value) !== 0) {
                formated_value = `(${formated_value})`;
            }
            if (original_value.includes("%")) {
                formated_value += "%";
            }
            if (original_value.includes(currency_details.symbol)) {
                formated_value = currency_details.symbol + formated_value;
            }
            if (original_value.includes('k')) {
                formated_value += 'k';
            }
            if (original_value.includes('M')) {
                formated_value += 'M';
            }
        } else {
            formated_value = original_value;
        }
        return formated_value
    }

    /** Clear the Original Value if any Symbols or whitespaces are there to do the Formating*/
    private cleanValue(original_value: any, currency_symbol: any) {
        return parseFloat(original_value
            .replace("(", "")
            .replace(")", "")
            .replace("%", "")
            .replace(currency_symbol, "")
            .trim());
    }
}

